// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c0629bea]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.news[data-v-c0629bea] {\n  width: 100%;\n  height: 100%;\n  min-width: 1280px;\n}\n", ""]);
// Exports
module.exports = exports;
